import Cookies from 'js-cookie';

const TokenKey = 'loginToken';

export function getToken(): string | undefined {
  return Cookies.get(TokenKey);
}

export function setToken(token: string): string | undefined {
  return Cookies.set(TokenKey, token, {
    secure: window.location.protocol === 'https:',
    sameSite: 'strict',
    expires: 1,
  });
}

export function removeToken(): void {
  Cookies.remove(TokenKey);
}
